import { render } from "./dots.vue?vue&type=template&id=4449ee6c&scoped=true&ts=true"
import script from "./dots.ts?vue&type=script&lang=ts"
export * from "./dots.ts?vue&type=script&lang=ts"

import "./dots.vue?vue&type=style&index=0&id=4449ee6c&style=true&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4449ee6c"]])

export default __exports__